import { EXPENSE_MANAGEMENT_ROUTE_NAMES } from '@/shared/common/constants/expenseManagementRoutes.constant';
import type { ExpenseManagementRouteName } from '@/shared/common/types/expenseManagementRoutes.type';

/**
 * Único punto de decisión por permisos de la ruta por defecto del módulo.
 * Hoy devuelve siempre `ADMINISTRATOR`; cuando el rol defina la pantalla de inicio,
 * el cambio se hace aquí y no en el router ni en el menú.
 */
export function resolveExpenseManagementHomeRouteName(): ExpenseManagementRouteName {
  return EXPENSE_MANAGEMENT_ROUTE_NAMES.ADMINISTRATOR;
}
